import Cookies from 'js-cookie';
import platform from 'platform';
import { getDefaultBuildToken, getKwikpassScript } from '../appconfig';
import { getUserIsLoggedIn, isIOSAppUser, isAndroidAppUser } from './helper';
import { v4 } from 'uuid';

export function getCookieValue(string, target) {
  if (!string) return null;

  let arr = string.split(';');
  for (let i = 0; i < arr.length; i++) {
    const key = arr[i].split('=')[0];
    const value = arr[i].split('=')[1];
    if (key.trim() == target) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export function getUserTokenSSR(cookiesString) {
  let cookies_value = getCookieValue(cookiesString, 'token');
  return cookies_value
    ? `Bearer ${getCookieValue(cookiesString, 'token')}`
    : `Bearer ${getDefaultBuildToken()}`;
}

export const getFilteredData = (data, keys) => {
  let obj = {};
  for (const key in data) {
    if (keys?.indexOf(key) !== -1) obj[`${key}`] = data[key];
  }
  return obj;
};

export const getFilteredArticleData = (articleData) => {
  let filteredArticleData = [];
  const contentKeys = [
    'webpImages',
    'multiImage',
    'files',
    'tagsWithId',
    'id',
    'web_url',
    'title',
    'url',
  ];
  const tagKeys = ['term_id', 'description'];
  const articleDataKeys = [
    'primary_tag_id',
    'content_type',
    'imageUrl',
    'content',
  ];
  articleData?.map((element) => {
    const articleDataobj = getFilteredData(element, articleDataKeys);
    const contentObj = getFilteredData(element?.content, contentKeys);
    articleDataobj.content = contentObj;
    const array = [];
    element?.content?.tagsWithId?.map((element) => {
      const tagsWithIdObj = getFilteredData(element, tagKeys);
      array.push(tagsWithIdObj);
    });
    articleDataobj.content.tagsWithId = array;
    filteredArticleData.push(articleDataobj);
  });
  return filteredArticleData;
};

export const fromB2G1CategoryPage = () => {
  const b2g1Page = Cookies.get('b2G1Page');
  return b2g1Page == 'true';
};

export const experimentalData = {
  'best-cloth-diapers': {
    firstLine: 'Baby ke liye only the best',
    secondLine: 'Mylo Cloth Diapers',
  },
  'doctor-recommended-diapers': {
    firstLine: "Doctor recommended for Baby's sensitive skin",
    secondLine: 'Mylo Cloth Diapers',
  },
  'newborn-cloth-diapers': {
    firstLine: "India's Safest Cloth diaper",
    secondLine: 'For Your Newborn Baby',
  },
  'reusable-diapers': {
    firstLine: 'Reusable • Washable • Adjustable',
    secondLine: 'Mylo Cloth Diapers',
  },
  'dry-rash-free-cloth-diapers': {
    firstLine: 'Keep Your Baby',
    secondLine: 'Dry and Rash Free',
  },
};
export const daiper_paths = Object.keys(experimentalData).map((path) => {
  return {
    params: {
      daiper: path,
    },
  };
});
export const daiper_experiment_urls = Object.keys(experimentalData).map(
  (path) => 'cloth-diapers/' + path,
);

export const isIosWebUser = () => platform?.os?.family?.includes('iOS');

export const getFilterUserImagesData = (user_images) => {
  let data = [];
  data = user_images.map((imagesData) => {
    return {
      id: imagesData?.id,
      object_id: imagesData?.object_id,
      image: imagesData?.image,
      contentType: imagesData?.contentType || '',
      content_type: imagesData?.content_type || '',
      content: filterContentDataPDP(imagesData?.content),
      rating: imagesData?.rating,
      helpful_counts: imagesData?.helpful_counts,
    };
  });

  return data;
};

const filterContentDataPDP = (data) => {
  return {
    id: data?.id || null,
    message: data?.message || null,
    body: data?.body || '',
    created_at: data?.created_at || null,
    updated_at: data?.updated_at || null,
    web_url: data?.web_url || null,
    webpImages: data?.webpImages || null,
    anonymous: data?.anonymous || null,
    title: data?.title || null,
    user_details: {
      stage: data?.user_details?.stage || null,
      followers: data?.user_details?.followers || null,
      webpImages: data?.user_details?.webpImages || null,
      thumbImages: data?.user_details?.thumbImages || null,
      username: data?.user_details?.username || null,
    },
    message: data?.message || null,
    tags: data?.tags || null,
    propertytags: data?.propertytags || null,
    comments: data?.comments || null,
    breadcrumbs: data?.breadcrumbs || null,
    meta_description: data?.meta_description || null,
    newFiles: data?.newFiles || {},
    feature_endorsed_doctor: {
      image: data?.feature_endorsed_doctor?.image || null,
    },
  };
};

export const getRandomShopDataValue = () =>
  Math.abs(Math.floor(1 + Math.random() * 2)) == 1 ? 'A' : 'B';

export const handleReturnExperimentValueSSR = (context) => {
  let cookieString = context.req.headers.cookie;
  let userType = getCookieValue(cookieString, 'shopData');
  if (!userType) {
    let shop_data = getRandomShopDataValue();
    userType = {
      userType: shop_data,
    };
    userType = JSON.stringify(userType);
    context.res.setHeader('Set-Cookie', `shopData=${userType}; Path=/;`);
  }
  return userType;
};

export const colors = { white: '#fff' };

export const l2CategoryOldIds = [
  5181, 5182, 6022, 6023, 6445, 6452, 6472, 6572, 6840, 6901, 6926, 6932, 6933,
  6985, 7145, 7502, 7518, 7522, 7523, 7524, 7570, 7572, 7573, 7574, 7575, 7579,
  7580, 7581, 7592, 7594, 7595, 7597,
];
export const l1CategoryIds = [
  7569, 7510, 7515, 7567, 7517, 7511, 7516, 7568, 7504, 7566, 7505, 7506, 7508,
  7507,
];

export const CategoryIdMapping = {
  5179: 5386,
  5181: 6281,
  5182: 7059,
  6022: 5366,
  6023: 7060,
  6445: 7062,
  6452: 7032,
  // 6472: 6472,
  6512: 6477,
  6560: 5433,
  6561: 6109,
  6572: 7031,
  6729: 7054,
  6734: 7049,
  6782: 5391,
  6840: 7061,
  // 6901: 6901,
  6933: 6695,
  6936: 7040,
  6938: 7039,
  6940: 7036,
  6985: 7528,
  // 7145: 7145,
  7167: 7195,
  7221: 7214,
  7222: 7212,
  7519: 7029,
  7520: 7028,
  7521: 7030,
  7523: 7051,
  7570: 7030,
  7571: 7197,
  // 7572: 7198,
  7573: 7203,
  7574: 7206,
  7575: 7204,
  7576: 7205,
  7577: 5131,
  7578: 5366,
  7579: 7048,
  7580: 7046,
  7581: 6702,
  7582: 7039,
  7585: 7213,
  7586: 5429,
  7587: 5430,
  7588: 7196,
  7589: 6143,
  7590: 6142,
  7591: 7202,
  7593: 6139,
  7594: 6144,
  7595: 6141,
};

export const OldCategoryIdUrlMapping = {
  5131: '/category/stretch-marks-removal-cream-7577',
  5356: '/category/skin-care-products-7510',
  // 5366: "/category/maternity-wear-products-7578",
  5386: '/category/baby-wipes-5179',
  5391: '/category/baby-carrier-6782',
  5429: '/category/anti-hairfall-and-anti-thinning-products-7586',
  5430: '/category/dry-damaged-hair-management-products-7587',
  // 5433: "/category/cloth-diapers-6560",
  6109: '/category/baby-swaddle-wraps-6561',
  6139: '/category/acne-blemishes-relieving-products-7593',
  6141: '/category/dull-dry-skin-management-products-7595',
  6142: '/category/anti-ageing-products-7590',
  6143: '/category/skin-brightening-products-7589',
  6144: '/category/dark-circles-removal-cream-7594',
  6281: '/category/diaper-bags-5181',
  // 6472: "/category/laundry-detergent-6472",
  6477: '/category/diaper-pants-6512',
  6695: '/category/baby-socks-6933',
  6702: '/category/baby-pillow-7581',
  // 6901: "/category/baby-towels-6901",
  7002: '/category/everyday-health-products-7515',
  7003: '/category/hygiene-products-7568',
  7004: '/category/pregnancy-new-mom-products-7569',
  7005: '/category/fertility-boosting-products-7517',
  7021: '/category/diapers-wipes-7504',
  7022: '/category/baby-care-7505',
  7023: '/category/baby-wellness-products-7566',
  7024: '/category/baby-activity-gear-7507',
  7025: '/category/baby-clothes-7508',
  7028: '/category/baby-hair-care-products-7520',
  7029: '/category/baby-skin-care-products-7519',
  7030: '/category/anti-colic-products-7570',
  7031: '/category/diaper-rash-cream-6572',
  7032: '/category/mosquito-repellent-6452',
  7036: '/category/pcos-management-products-6940',
  7039: '/category/digestive-health-management-products-7582',
  7040: '/category/weight-management-products-6936',
  7046: '/category/baby-sleeping-bags-carry-nest-7580',
  7048: '/category/baby-dry-sheet-7579',
  7049: '/category/baby-potty-seat-bathtub-6734',
  7051: '/category/baby-winter-clothes-7523',
  7054: '/category/baby-stroller-6729',
  7059: '/category/feeding-bottle-5182',
  7060: '/category/baby-nipple-grooved-6023',
  7061: '/category/baby-fruit-feeder-6840',
  7062: '/category/breast-pump-6445',
  7063: '/category/feeding-lactation-7506',
  // 7145: "/category/baby-cap-mittens-booties-7145",
  7195: '/category/pregnancy-test-kit-7167',
  7196: '/category/hair-growth-products-7588',
  7198: '/category/brightening-skin-care-products-7572',
  7202: '/category/skin-hydration-products-7591',
  7203: '/category/tan-removal-products-7573',
  7204: '/category/lactation-products-7575',
  7205: '/category/maternity-gear-products-7576',
  7206: '/category/urinary-tract-infection-relieving-products-7574',
  7212: '/category/female-fertility-products-7222',
  7213: '/category/ovulation-test-kit-7585',
  7214: '/category/male-fertility-products-7221',
  7528: '/category/sipper-bottle-6985',
};

export const setWebUserIdReact = (cart_id) => {
  if (
    cart_id ||
    (!getUserIsLoggedIn() && !Cookies.get('web_user_id_react')) ||
    isIOSAppUser()
  ) {
    if (cart_id) {
      Cookies.set('web_user_id_react', cart_id, {
        expires: 365,
        path: '/',
      });
    } else {
      let webUserId = v4().split('-').splice(2, 5).join('-');
      Cookies.set('web_user_id_react', webUserId, {
        expires: 365,
        path: '/',
      });
      Cookies.set('new_user', 'true');
    }
  }
};

export function isAppUser() {
  return isAndroidAppUser() || isIOSAppUser();
}

export const showDiaperSwitch = (userType) => {
  return true;
};

export const getNewAndRepeatUser = () => {
  if (!sessionStorage.getItem('session_on')) {
    sessionStorage.setItem('session_on', 'true');
    if (Cookies.get('new_user')) {
      Cookies.remove('new_user');
      sessionStorage.setItem('user_type', 'new_user');
      return 'new_user';
    } else {
      sessionStorage.setItem('user_type', 'repeat_user');
      return 'repeat_user';
    }
  } else {
    return sessionStorage.getItem('user_type');
  }
};

export const checkEligibilityForSsoTooltip = () => {
  let tooltipSessionData = sessionStorage.getItem('kwikpass_sso_tooltip');
  let showKwikPassSsoTooltip = false;
  if (tooltipSessionData != undefined) {
    showKwikPassSsoTooltip = tooltipSessionData === 'true';
  } else {
    showKwikPassSsoTooltip = Cookies.get('show_sso_tooltip') == 'true';
  }

  return showKwikPassSsoTooltip;
};
